import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/offerOverlayLink';

export const OFFER_OVERLAY_LINK_CLICK = `${rootActionPath}/CLICK`;
export const OFFER_OVERLAY_LINK_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const OFFER_OVERLAY_LINK_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
